import './index.css'

const About = () => (
  <div className="about-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/about-blog-img.png"
      alt="about"
      className="about-img"
    />
    <h1 className="about-heading">About</h1>
    <p className="about-paragraph">
      Hello, I am Dileep from Srikakulam, Andhra Pradesh, India. I did my
      Bachelors of Technology at Rajiv Gandhi University of Knowledge and
      Technologies in 2022 in the Mechanical Engineering stream. I worked on
      many projects in Full Stack Development by spending 150 million minutes
      learning to code. I love to code and design products.
    </p>
  </div>
)

export default About
